import { Directus } from "@directus/sdk";
import { get_db_base } from "./Functions";
import { GlobalSettings as WFProHc_GlobalSettings } from "../projects/_modular/data/types/globalSettings";
import { ModuleCarousel as WFProHc_ModuleCarousel } from "../projects/_modular/data/types/moduleCarousel";
import { ModuleHeader as WFProHc_ModuleHeader } from "../projects/_modular/data/types/moduleHeader";
import { ModuleHotspots as WFProHc_ModuleHotspots } from "../projects/_modular/data/types/moduleHotspots";
import { ModuleNavigationV2 as WFProHc_ModuleNavigationV2 } from "../projects/_modular/data/types/moduleNavigationV2";
import { ModuleTabbedContent as WFProHc_ModuleTabbedContent } from "../projects/_modular/data/types/moduleTabbedContent";
import { Page as WFProHc_Page } from "../projects/_modular/data/types/pages";
import { ModuleSize as WFProHc_ModuleSize } from "../projects/_modular/data/types/moduleSize";
import { ModuleDisclaimers as WFProHc_ModuleDisclaimers } from "../projects/_modular/data/types/moduleDisclaimers";
import { Promo as WFProHc_Promo } from "../projects/_modular/data/types/promos";
import { ModuleDataTable as WFProHc_ModuleDataTable } from "../projects/_modular/data/types/moduleDataTable";
import { Locale as WFProHc_Locale } from "../projects/_modular/data/types/locale";
import { ModuleRteWithLogo as WFProHc_ModuleRteWithLogo } from "../projects/_modular/data/types/moduleRteWithLogo";
import { Family as WFProHc_Family } from "../projects/_modular/data/types/family";
import { Brand as WFProHc_Brand } from "../projects/_modular/data/types/brand";
import { ModuleConfigTool as WFProHc_ModuleConfigTool } from "../projects/_modular/data/types/moduleConfigTool";
import { Attribute as WFProHc_Attribute } from "../projects/_modular/data/types/attributes";
import { Disclaimer as WFProHc_Disclaimer } from "../projects/_modular/data/types/disclaimers";
import { SpecificationStyle as WFProHc_SpecificationStyle } from "../projects/_modular/data/types/specificationStyles";
import { ProductType as WFProHc_ProductType } from "../projects/_modular/data/types/productType";
import { PriceType as WFProHc_PriceType } from "../projects/_modular/data/types/priceType";
import { Product as WFProHc_Product } from "../projects/_modular/data/types/product";
import { IndexPage as POS_IndexPage } from "../projects/pos/data/types/indexPage";
import { Promo as POS_Promo } from "../projects/pos/data/types/promos";
import { Disclaimer as POS_Disclaimer } from "../projects/pos/data/types/disclaimers";
import { GlobalSettings as POS_GlobalSettings } from "../projects/pos/data/types/globalSettings";
import { FindByFeaturesPage as POS_FindByFeaturesPage } from "../projects/pos/data/types/findByFeaturesPage";
import { Category as POS_Category } from "../projects/pos/data/types/categories";
import { Attribute as POS_Attribute } from "../projects/pos/data/types/attributes";
import { Brand as POS_Brand } from "../projects/pos/data/types/brands";
import { Family as POS_Family } from "../projects/pos/data/types/family";
import { Accessory as POS_Accessory } from "../projects/pos/data/types/accessories";
import { ServicePlan as POS_ServicePlan } from "../projects/pos/data/types/servicePlans";
import { LabeledImage as POS_LabeledImage } from "../projects/pos/data/types/labeledImages";
import { TableHeader as POS_TableHeader } from "../projects/pos/data/types/tableHeaders";
import { TableLegendKey as POS_TableLegendKey } from "../projects/pos/data/types/tableLegendKeys";
import { ModuleHeader as POS_ModuleHeader } from "../projects/pos/data/types/moduleHeader";
import { Product as POS_Product } from "../projects/pos/data/types/products";
import { ComparisonPage as POS_ComparisonPage } from "../projects/pos/data/types/comparisonPages";
import { SkuOption as POS_SkuOption } from "../projects/pos/data/types/skuOptions";
import { Color as POS_Color } from "../projects/pos/data/types/colors";
import { Attribute as PSeries_Attribute } from "../projects/p-series/data/types/attributes";
import { Blurb as PSeries_Blurb } from "../projects/p-series/data/types/blurbs";
import { Brand as PSeries_Brand } from "../projects/p-series/data/types/brands";
import { ComparisonPage as PSeries_ComparisonPage } from "../projects/p-series/data/types/comparisonPages";
import { Contact as PSeries_Contact } from "../projects/p-series/data/types/contacts";
import { Currency as PSeries_Currency } from "../projects/p-series/data/types/currencies";
import { Disclaimer as PSeries_Disclaimer } from "../projects/p-series/data/types/disclaimers";
import { FindByFeaturesPage as PSeries_FindByFeaturesPage } from "../projects/p-series/data/types/findByFeaturesPage";
import { GlobalSettings as PSeries_GlobalSettings } from "../projects/p-series/data/types/globalSettings";
import { GlossaryTerm as PSeries_GlossaryTerm } from "../projects/p-series/data/types/glossaryTerms";
import { IndexPage as PSeries_IndexPage } from "../projects/p-series/data/types/indexPage";
import { Ink as PSeries_Ink } from "../projects/p-series/data/types/inks";
import { Language as PSeries_Language } from "../projects/p-series/data/types/languages";
import { PriceType as PSeries_PriceType } from "../projects/p-series/data/types/priceTypes";
import { Product as PSeries_Product } from "../projects/p-series/data/types/products";
import { Promo as PSeries_Promo } from "../projects/p-series/data/types/promos";
import { QuickComparePage as PSeries_QuickComparePage } from "../projects/p-series/data/types/quickComparePage";
import { WinLogic as PSeries_WinLogic } from "../projects/p-series/data/types/winLogic";

type PSeries = {
  attributes: PSeries_Attribute;
  blurbs: PSeries_Blurb;
  brands: PSeries_Brand;
  comparison_pages: PSeries_ComparisonPage;
  contacts: PSeries_Contact;
  currencies: PSeries_Currency;
  disclaimers: PSeries_Disclaimer;
  find_by_features_page: PSeries_FindByFeaturesPage;
  global_settings: PSeries_GlobalSettings;
  glossary_terms: PSeries_GlossaryTerm;
  index_page: PSeries_IndexPage;
  inks: PSeries_Ink;
  languages: PSeries_Language;
  price_types: PSeries_PriceType;
  products: PSeries_Product;
  promos: PSeries_Promo;
  quick_compare_page: PSeries_QuickComparePage;
  win_logic: PSeries_WinLogic;
};

type WfProHc = {
  // [collection_name]: typescript_type
  attributes: WFProHc_Attribute;
  brands: WFProHc_Brand;
  disclaimers: WFProHc_Disclaimer;
  families: WFProHc_Family;
  global_settings: WFProHc_GlobalSettings;
  locales: WFProHc_Locale;
  module_carousel: WFProHc_ModuleCarousel;
  module_config_tool: WFProHc_ModuleConfigTool;
  module_data_table: WFProHc_ModuleDataTable;
  module_disclaimers: WFProHc_ModuleDisclaimers;
  module_header: WFProHc_ModuleHeader;
  module_hotspots: WFProHc_ModuleHotspots;
  module_navigation_v2: WFProHc_ModuleNavigationV2;
  module_rte_with_logo: WFProHc_ModuleRteWithLogo;
  module_sizes: WFProHc_ModuleSize;
  module_tabbed_content: WFProHc_ModuleTabbedContent;
  pages: WFProHc_Page;
  price_types: WFProHc_PriceType;
  products: WFProHc_Product;
  product_types: WFProHc_ProductType;
  promos: WFProHc_Promo;
  specification_styles: WFProHc_SpecificationStyle;
};

type POS = {
  index_page: POS_IndexPage;
  promos: POS_Promo;
  disclaimers: POS_Disclaimer;
  global_settings: POS_GlobalSettings;
  find_by_features_page: POS_FindByFeaturesPage;
  categories: POS_Category;
  attributes: POS_Attribute;
  brands: POS_Brand;
  families: POS_Family;
  accessories: POS_Accessory;
  service_plans: POS_ServicePlan;
  labeled_images: POS_LabeledImage;
  table_headers: POS_TableHeader;
  table_legend_keys: POS_TableLegendKey;
  module_header: POS_ModuleHeader;
  products: POS_Product;
  comparison_pages: POS_ComparisonPage;
  sku_option_configurations: POS_SkuOption;
  colors: POS_Color;
};

declare global {
  namespace NodeJS {
    interface ProcessEnv {
      REACT_APP_DB_URL: string;
      REACT_APP_PB_TOKEN: string;
    }
  }
}

function getProject(project: string, db_base: string) {
  switch (project) {
    case "wf-pro-hc":
      return new Directus<WfProHc>(db_base, {
        // auth: { staticToken: process.env.REACT_APP_PB_TOKEN }
        // auth: undefined
      });
    case "pos":
    case "latin-pos":
      return new Directus<POS>(db_base);
    case "p-series":
    // t-series reuses the p-series schema (it is a copy of it)
    case "t-series":
      return new Directus<PSeries>(db_base);

    default:
      return null;
  }
}
export async function getItems(project: string, config: any, localeId: any) {
  const { collection, filter, fields: fieldsOrFn } = config || {};
  const fields =
    typeof fieldsOrFn === "function" ? fieldsOrFn(project) : fieldsOrFn;
  const db_base = get_db_base(project);
  // Let the SDK know about your collection types.
  const directus = getProject(project, db_base);
  //   await directus.auth.static(process.env.REACT_APP_PB_TOKEN);
  if (config?.system) {
    const params = new URLSearchParams({
      limit: "-1",
      fields: fields?.join(",")
    });
    const res = await fetch(`${db_base}${collection}?${params}`);
    const json = await res.json();
    return json?.data;
  }
  const { data } =
    (await directus
      ?.items(collection)
      ?.readByQuery({ limit: -1, filter: filter, fields: fields })) || {};
  return data;
}

// Ugh.
const defaultProject = window.location.pathname.split("/")[1];
export function getImageUrl(id: string, project: string) {
  if (!id) return "";
  const projectToLinkTo = project || defaultProject;
  const url = `${get_db_base(projectToLinkTo)}/assets/${id}`.replace(
    "//assets",
    "/assets"
  );
  return url;
}

export function addImageUrl(obj: any, imageProperty: string, project: string) {
  return obj?.[imageProperty]?.id
    ? {
        title: obj[imageProperty]?.title,
        url: getImageUrl(obj[imageProperty].id, project)
      }
    : null;
}

//gets finds correct locale within obj.locale by matching localeProp with localeId
export function getLocale(obj: any, localeProp: any, localeId: any) {
  return (
    obj?.locale?.find((locale: any) => locale?.[localeProp]?.id === localeId) ||
    obj?.locale?.[0]
  );
}

//gets property from the proper locale
//takes in optional requirements if it's an image
export function getLocalized(args: any) {
  const { obj, field, localeProp, localeId, project, isImage } = args;
  const selectedLocale = getLocale(obj, localeProp, localeId);
  const defaultLocale = obj.locale?.[0];
  if (isImage) {
    return (
      addImageUrl(selectedLocale, field, project) ||
      addImageUrl(defaultLocale, field, project)
    );
  } else return selectedLocale?.[field] || defaultLocale?.[field];
}
